import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  UrlTree,
  CanActivateChild
} from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { isAuthenticated } from './selectors/auth.selectors';
import {
  map,
  tap
} from 'rxjs/operators';
import { NGXLogger } from 'ngx-logger';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationGuard
  implements CanActivate, CanActivateChild {

  constructor(
    public store$: Store<any>,
    public router: Router,
    public logger: NGXLogger,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | boolean {
    return this.store$.select(isAuthenticated).pipe(
      tap(isAuth => this.logger.debug('[AuthenticationGuard]', { isAuth, next, state })),
      map(isAuth => isAuth || this.router.createUrlTree(['/', 'auth']))
    );
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivate(childRoute, state);
  }

}
